// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SigninRouteImport } from './routes/signin'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as LoginRouteImport } from './routes/login'
import { Route as DemoRouteImport } from './routes/demo'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as AppRouteImport } from './routes/_app'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppSettingsRouteImport } from './routes/_app.settings'
import { Route as AppRoutingRouteImport } from './routes/_app.routing'
import { Route as AppOnboardingRouteImport } from './routes/_app.onboarding'
import { Route as AppLiveRouteImport } from './routes/_app.live'
import { Route as AppIvrRouteImport } from './routes/_app.ivr'
import { Route as AppDashboardRouteImport } from './routes/_app.dashboard'
import { Route as AppBranchesRouteImport } from './routes/_app.branches'
import { Route as AppAgentsRouteImport } from './routes/_app.agents'
import { Route as AppAdminRouteImport } from './routes/_app.admin'
import { Route as AppCallsIndexRouteImport } from './routes/_app.calls.index'
import { Route as AppCallsIdRouteImport } from './routes/_app.calls.$id'

const SigninRoute = SigninRouteImport.update({
            id: '/signin',path: '/signin',getParentRoute: () => rootRouteImport
          })
const SignInRoute = SignInRouteImport.update({
            id: '/sign-in',path: '/sign-in',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const DemoRoute = DemoRouteImport.update({
            id: '/demo',path: '/demo',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const AppRoute = AppRouteImport.update({
            id: '/_app',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AppSettingsRoute = AppSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => AppRoute
          })
const AppRoutingRoute = AppRoutingRouteImport.update({
            id: '/routing',path: '/routing',getParentRoute: () => AppRoute
          })
const AppOnboardingRoute = AppOnboardingRouteImport.update({
            id: '/onboarding',path: '/onboarding',getParentRoute: () => AppRoute
          })
const AppLiveRoute = AppLiveRouteImport.update({
            id: '/live',path: '/live',getParentRoute: () => AppRoute
          })
const AppIvrRoute = AppIvrRouteImport.update({
            id: '/ivr',path: '/ivr',getParentRoute: () => AppRoute
          })
const AppDashboardRoute = AppDashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => AppRoute
          })
const AppBranchesRoute = AppBranchesRouteImport.update({
            id: '/branches',path: '/branches',getParentRoute: () => AppRoute
          })
const AppAgentsRoute = AppAgentsRouteImport.update({
            id: '/agents',path: '/agents',getParentRoute: () => AppRoute
          })
const AppAdminRoute = AppAdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => AppRoute
          })
const AppCallsIndexRoute = AppCallsIndexRouteImport.update({
            id: '/calls/',path: '/calls/',getParentRoute: () => AppRoute
          })
const AppCallsIdRoute = AppCallsIdRouteImport.update({
            id: '/calls/$id',path: '/calls/$id',getParentRoute: () => AppRoute
          })





const AppRouteChildren = {
  AppAdminRoute: AppAdminRoute,AppAgentsRoute: AppAgentsRoute,AppBranchesRoute: AppBranchesRoute,AppDashboardRoute: AppDashboardRoute,AppIvrRoute: AppIvrRoute,AppLiveRoute: AppLiveRoute,AppOnboardingRoute: AppOnboardingRoute,AppRoutingRoute: AppRoutingRoute,AppSettingsRoute: AppSettingsRoute,AppCallsIdRoute: AppCallsIdRoute,AppCallsIndexRoute: AppCallsIndexRoute
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AppRoute: AppRouteWithChildren,AuthRoute: AuthRoute,DemoRoute: DemoRoute,LoginRoute: LoginRoute,SignInRoute: SignInRoute,SigninRoute: SigninRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)